import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icon/success_modal.svg")